var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSecuritySecuritybicolor2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 600,
    enableBackground: "new 0 0 612 792",
    viewBox: "0 0 600 600",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient937",
    x1: 68.16,
    x2: 527.16,
    y1: 373.04,
    y2: 373.04,
    gradientTransform: "matrix(1,0,0,-1,8.3398,768.04)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB00",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD901",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD205",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC70B",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC00F",
    offset: 0.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Security",
    transform: "translate(-1.8701 -86.026)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.0001 0 0 1.0027 -1.6787 -86.987)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m306 127.25-229.5 114.75v114.75c0 114.75 95.625 262.01 229.5 306 133.88-43.987 229.5-191.25 229.5-306v-114.75zm-38.25 382.5-114.75-114.75 38.25-38.25 76.5 76.5 153-153 38.25 38.25z",
    fill: "url(#linearGradient937)",
    stroke: "#fc0",
    strokeMiterlimit: 10
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecuritySecuritybicolor2);
export default __webpack_public_path__ + "static/media/Security_Security bicolor 2.b6617bb1765c5946c014ccdd936e6703.svg";
export { ForwardRef as ReactComponent };